// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProblemsProgress_wrapper__3OnGA","filled":"ProblemsProgress_filled__vjEDM","inner":"ProblemsProgress_inner__1GAVl","list":"ProblemsProgress_list__2Thai"};